import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard,
  Users,
  CalendarCheck,
  Clock,
  Wallet,
  FileText,
  Banknote
} from 'lucide-react';
import { Sidebar } from './layout/Sidebar';
import { MobileHeader } from './layout/MobileHeader';
import { MobileMenu } from './layout/MobileMenu';
import { BottomNav } from './layout/BottomNav';

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/workers', label: 'Workers', icon: Users },
  { path: '/attendance', label: 'Attendance', icon: CalendarCheck },
  { path: '/leaves', label: 'Leaves', icon: Clock },
  { path: '/advances', label: 'Advances', icon: Wallet },
  { path: '/payouts', label: 'Payouts', icon: Banknote },
  { path: '/reports', label: 'Reports', icon: FileText },
];

// 5 most-used destinations for the mobile bottom bar (computed once, not per render)
const BOTTOM_NAV_PATHS = ['/dashboard', '/workers', '/attendance', '/advances', '/reports'];
const bottomNavItems = navItems.filter((i) => BOTTOM_NAV_PATHS.includes(i.path));

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="min-h-screen bg-[#F4F4F0]">
      <Sidebar navItems={navItems} user={user} onLogout={handleLogout} />

      <MobileHeader
        isMenuOpen={isMobileMenuOpen}
        onToggleMenu={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />

      {isMobileMenuOpen && (
        <MobileMenu
          navItems={navItems}
          user={user}
          onClose={() => setIsMobileMenuOpen(false)}
          onLogout={handleLogout}
        />
      )}

      <BottomNav items={bottomNavItems} />

      <main className="md:ml-64 pt-16 md:pt-0 pb-20 md:pb-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
